import {
  ATTRIBUTE_SUPPLIERS_MINIMUM,
  EMPTY_STRING,
  INTERVIEW_TABS,
  NO_VALUE_RESPONSE,
  SCALED_SLIDER_DEFAULT_VALUE,
  ZERO,
} from '@constants';
import { ATTRIBUTE_TYPE, AttributeDetails, ScoresField, ScoresForm, SupplierScoreField } from '@customTypes';

export const getInterviewTab = (type: ATTRIBUTE_TYPE) => {
  switch (type) {
    case ATTRIBUTE_TYPE.SERVICE:
      return INTERVIEW_TABS.SERVICE_SCORES;
    case ATTRIBUTE_TYPE.IMAGE:
      return INTERVIEW_TABS.IMAGE_SCORES;
    default:
      return INTERVIEW_TABS.PRODUCT_SCORES;
  }
};

export const getDefaultAttributes = (attributes: AttributeDetails[], type: ATTRIBUTE_TYPE): ScoresField[] => {
  return attributes
    .filter((item) => item.type === type)
    .map(({ note, seq, suppliersScores, name, description, included, importance, type }) => ({
      attributeId: seq,
      name,
      description,
      included,
      type,
      importance: importance === NO_VALUE_RESPONSE ? SCALED_SLIDER_DEFAULT_VALUE : importance,
      note: note ?? EMPTY_STRING,
      supplierScores: Object.entries(suppliersScores).map(([supplier, score]) => ({
        supplier,
        score: score && score !== NO_VALUE_RESPONSE ? score : SCALED_SLIDER_DEFAULT_VALUE,
        included: included && score !== NO_VALUE_RESPONSE,
      })),
    }));
};

export const isAttributeValid = (suppliers?: SupplierScoreField[]) => {
  const includedSuppliers = suppliers?.filter((score) => score.included).length || ZERO;

  return includedSuppliers >= ATTRIBUTE_SUPPLIERS_MINIMUM;
};

const getSuppliersScores = (data?: SupplierScoreField[]) => {
  return (
    data?.reduce((acc: Record<string, number>, item) => {
      const { score, included, supplier } = item;

      if (score) {
        acc[supplier] = included ? score : NO_VALUE_RESPONSE;
      }

      return acc;
    }, {}) || {}
  );
};

export const getScoresPayload = (data: ScoresForm, type: ATTRIBUTE_TYPE): AttributeDetails[] => {
  return data.attributes.map(({ attributeId, included, name, description, note, supplierScores, importance }) => ({
    seq: attributeId,
    included,
    name,
    description: description ?? EMPTY_STRING,
    note: note ?? EMPTY_STRING,
    importance: included && importance ? importance : NO_VALUE_RESPONSE,
    type,
    suppliersScores: getSuppliersScores(supplierScores),
  }));
};
